import React, { useState, useContext, useMemo } from 'react'

import {
  strCol,
  // dateCol,
  numCol,
} from '@integec/grid-tools/lib/cols'
import Grid, {
  virtualizedGridRenderer,
  freeEditEngine,
  VirtualizedCell,
  defaultVirtualizedCellRender,
  // extractAndFormatData,
} from '@integec/grid-tools'
import R from 'ramda'
import { rowHeaderRender } from 'core/utils'
import { Button, Modal } from 'antd'
import {
  saveGenerationHourly,
  deleteGenerationHourly,
  saveGenerationHourlyAux,
  deleteGenerationHourlyAux,
  // getDateHourList,
} from 'api/pgads'
import { ErrorContext, SpinContext } from 'context'
import moment from 'moment'
const HourlyGenerationDetails = ({
  apitargetInfo,
  data = [],
  onRetrieveData,
  utilityNameMap = {},
  unitNameMap = {},
  setInsertEvent,
  dateHourList,
  width = 1250,
  hourlyGenerationwithSynch = false,
  hourlyGenerationwithPump = false,
  hourlyGenerationwithAux = false,
  hourlyGenerationHideDelete = false,
  // eslint-disable-next-line no-unused-vars
  ...props
}) => {
  const { setError } = useContext(ErrorContext)
  const { setSpinning } = useContext(SpinContext)

  const [editInfo, setEditInfo] = useState(
    freeEditEngine.generateInitialEditInfo()
  )
  const onEditRow = editInfo => {
    // let editData = editInfo.updated
    // editData = editData.map(d => ({
    //   ...d,

    //   modificationInfo: undefined,
    // }))
    setEditInfo(editInfo)

    // let editData = editInfo.updated
    // editData = editData.map(d => ({
    //   ...d,
    // }))

    // setEditInfo({ ...editInfo, updated: editData })
  }

  const headers = useMemo(
    _ => {
      const { transdate } = data[0]
      const dateHour =
        (dateHourList.find(d => d.date === transdate) || {}).hours || []

      const header = R.range(1, 25).map(i =>
        numCol({
          ident: 'hr' + i,
          display: 'HR ' + i,
          width: 60,
          idx: i,
        })
      )

      let hourList = [
        strCol({ ident: 'display', display: 'Display', isKey: true }),
        ...header,
      ]

      if (dateHour.length > 0 && !dateHour.find(d => d === 3))
        hourList = hourList.filter(h => h.idx !== 3)

      if (dateHour.find(d => d === 2.2))
        hourList.push(numCol({ ident: 'hr2a', display: 'HR-2A', idx: 25 }))

      hourList.push(numCol({ ident: 'total', display: 'Total', width: 90 }))

      return hourList
    },

    [data, dateHourList]
  )

  const updateData = bool => {
    const newRow = freeEditEngine.applyEdits({
      data: data,
      editInfo,
    })

    const grossRow = newRow.find(d => d.display === 'GROSS')
    const ssRow = newRow.find(d => d.display === 'SS')
    const netRow = newRow.find(d => d.display === 'NET')
    const pumpRow = newRow.find(d => d.display === 'PUMP') || {}
    const synchRow = newRow.find(d => d.display === 'SYNC') || {}
    const onlineAuxRow = newRow.find(d => d.display === 'ONLINE AUX') || {}
    const offlineAuxRow = newRow.find(d => d.display === 'OFFLINE AUX') || {}

    const { transdate, unit, utility, unitId } = grossRow

    const saveDataType = (data, type) =>
      R.range(1, 25).map(i => ({ [type + i]: data['hr' + i] }))

    let saveNetData = saveDataType(netRow, 'net')
    let saveSSData = hourlyGenerationwithAux
      ? R.range(1, 25).map(i => ({
          ['ss' + i]:
            parseFloat(onlineAuxRow['hr' + i] || 0) +
            parseFloat(offlineAuxRow['hr' + i] || 0),
        }))
      : saveDataType(ssRow, 'ss')

    let saveGrossData = R.range(1, 25).map(i => {
      const netI = parseFloat(netRow['hr' + i] || 0)
      return {
        ['gross' + i]: hourlyGenerationwithAux
          ? netI === 0
            ? 0
            : netI +
              parseFloat(onlineAuxRow['hr' + i] || 0) +
              parseFloat(offlineAuxRow['hr' + i] || 0)
          : netI === 0
          ? 0
          : netI + parseFloat(ssRow['hr' + i] || 0),
      }
    })
    saveGrossData = R.reduce(
      (a, b) => ({ ...a, ...b }),
      {
        transdate,
        unit,
        utility,
        unitId,
        gross2a: hourlyGenerationwithAux
          ? parseFloat(netRow.hr2a || 0) === 0
            ? 0
            : parseFloat(netRow.hr2a || 0) +
              parseFloat(onlineAuxRow.hr2a || 0) +
              parseFloat(offlineAuxRow.hr2a || 0)
          : parseFloat(netRow.hr2a || 0) === 0
          ? 0
          : parseFloat(netRow.hr2a || 0) + parseFloat(ssRow.hr2a || 0),
      },
      saveGrossData
    )

    saveSSData = R.reduce(
      (a, b) => ({ ...a, ...b }),
      {
        ss2a: hourlyGenerationwithAux
          ? parseFloat(onlineAuxRow.hr2a || 0) +
            parseFloat(offlineAuxRow.hr2a || 0)
          : ssRow.hr2a,
      },
      saveSSData
    )

    saveNetData = R.reduce(
      (a, b) => ({ ...a, ...b }),
      { net2a: netRow.hr2a },
      saveNetData
    )

    let saveSynchData = {}
    if (hourlyGenerationwithSynch) {
      saveSynchData = saveDataType(synchRow, 'sync')
      saveSynchData = R.reduce(
        (a, b) => ({ ...a, ...b }),
        { sync2a: synchRow.hr2a },
        saveSynchData
      )
    }

    let savePumpData = {}
    if (hourlyGenerationwithPump) {
      savePumpData = saveDataType(pumpRow, 'pump')
      savePumpData = R.reduce(
        (a, b) => ({ ...a, ...b }),
        { pump2a: pumpRow.hr2a },
        savePumpData
      )
    }

    let saveOnlineAuxData = {}
    let saveOfflineAuxData = {}
    if (hourlyGenerationwithAux) {
      saveOnlineAuxData = saveDataType(onlineAuxRow, 'onlineAux')
      saveOnlineAuxData = R.reduce(
        (a, b) => ({ ...a, ...b }),
        { onlineAux2a: onlineAuxRow.hr2a },
        saveOnlineAuxData
      )
      saveOfflineAuxData = saveDataType(offlineAuxRow, 'offlineAux')
      saveOfflineAuxData = R.reduce(
        (a, b) => ({ ...a, ...b }),
        { offlineAux2a: offlineAuxRow.hr2a },
        saveOfflineAuxData
      )
    }

    const saveData = {
      ...saveGrossData,
      ...saveSSData,
      ...saveNetData,
      ...(hourlyGenerationwithPump ? savePumpData : {}),
      ...(hourlyGenerationwithSynch ? saveSynchData : {}),
      ...(hourlyGenerationwithAux ? saveOnlineAuxData : {}),
      ...(hourlyGenerationwithAux ? saveOfflineAuxData : {}),
    }

    const saveFn = hourlyGenerationwithAux
      ? saveGenerationHourlyAux
      : saveGenerationHourly
    saveFn(apitargetInfo)([saveData]).fork(setError, _ => {
      setSpinning(false)
      onRetrieveData(bool ? { unitId, transdate } : null)
    })
  }

  // const getTotal = key => {
  //   const keyData = data.find(d => d.display === key)
  //   if (!keyData) return
  //   const modKeyData = freeEditEngine.applyEdits({
  //     data: [keyData],
  //     editInfo,
  //   })[0]
  //   const total = R.range(1, 25)
  //     .map(i => modKeyData['hr' + i])
  //     .reduce((a, b) => parseFloat(a || 0) + parseFloat(b || 0))
  //   return parseFloat(total + parseFloat(modKeyData.hr2a || 0)).toFixed(2)
  // }

  const deleteData = _ => {
    const { transdate, unit, unitId, utility } = data[0]

    Modal.confirm({
      content:
        'Are you sure you want to delete Genearation data for ' +
        unitNameMap[unitId] +
        '(' +
        utility +
        '-' +
        unit +
        ') Date : ' +
        moment(transdate).format('MM/DD/YYYY') +
        ' ?',
      title: 'Delete Generation',
      onOk() {
        setSpinning(true)
        const deleteFn = hourlyGenerationwithAux
          ? deleteGenerationHourlyAux
          : deleteGenerationHourly
        deleteFn(apitargetInfo)([data[0]]).fork(setError, _ => {
          setSpinning(false)
          setInsertEvent(false)
          onRetrieveData()
        })
      },
      onCancel() {},
    })
  }

  if (!data) return <div>No Data Found</div>

  const customizedCellRender = params => {
    const { gridToolProps, reactVirtualizedProps } = params

    const { getCellProps, headers, data } = gridToolProps

    const { columnIndex, rowIndex, style } = reactVirtualizedProps
    // const cellProps = getCellProps({
    //   rowIndex,
    //   columnIndex,
    //   header: headers[columnIndex],
    //   data,
    //   style,
    //   ...rest,
    // })

    // const cellData = extractAndFormatData({
    //   rowData: data[rowIndex],
    //   header: headers[columnIndex],
    // })

    const rowData = data[rowIndex]

    if (headers[columnIndex].ident === 'total') {
      const cellProp = getCellProps({
        rowIndex,
        columnIndex,
        header: headers[columnIndex],
        data,
        style,
      })
      let sum
      if (hourlyGenerationwithAux && rowData.display === 'SS') {
        const onlineAuxRow = data.find(d => d.display === 'ONLINE AUX') || {}
        const offlineAuxRow = data.find(d => d.display === 'OFFLINE AUX') || {}
        sum = R.range(1, 25)
          .map(
            i =>
              parseFloat(onlineAuxRow['hr' + i] || 0) +
              parseFloat(offlineAuxRow['hr' + i] || 0)
          )
          .reduce((a, b) => a + b, 0)
        sum +=
          parseFloat(onlineAuxRow.hr2a || 0) +
          parseFloat(offlineAuxRow.hr2a || 0)
      } else {
        sum = R.range(1, 25)
          .map(i => parseFloat(rowData['hr' + i] || 0))
          .reduce((a, b) => a + b, 0)
        sum += parseFloat(rowData.hr2a || 0)
      }
      const total = parseFloat(sum).toFixed(3)
      return (
        <VirtualizedCell {...R.omit(['data'], cellProp)}>
          {total}
        </VirtualizedCell>
      )
    }

    if (
      rowData.display === 'GROSS' &&
      headers[columnIndex].ident.startsWith('hr')
    ) {
      const curhourIdent = headers[columnIndex].ident
      const netRow = data.find(d => d.display === 'NET')
      const ssRow = data.find(d => d.display === 'SS') || {}
      const onlineAuxRow = data.find(d => d.display === 'ONLINE AUX') || {}
      const offlineAuxRow = data.find(d => d.display === 'OFFLINE AUX') || {}
      const cellProp = getCellProps({
        rowIndex,
        columnIndex,
        header: headers[columnIndex],
        data,
        style,
      })
      const netVal = parseFloat(netRow[curhourIdent] || 0)
      const val = hourlyGenerationwithAux
        ? netVal === 0
          ? 0
          : netVal +
            parseFloat(onlineAuxRow[curhourIdent] || 0) +
            parseFloat(offlineAuxRow[curhourIdent] || 0)
        : netVal === 0
        ? 0
        : netVal + parseFloat(ssRow[curhourIdent] || 0)

      return (
        <VirtualizedCell {...R.omit(['data'], cellProp)}>{val}</VirtualizedCell>
      )
    }

    if (
      hourlyGenerationwithAux &&
      rowData.display === 'SS' &&
      headers[columnIndex].ident.startsWith('hr')
    ) {
      const curhourIdent = headers[columnIndex].ident
      const onlineAuxRow = data.find(d => d.display === 'ONLINE AUX') || {}
      const offlineAuxRow = data.find(d => d.display === 'OFFLINE AUX') || {}
      const cellProp = getCellProps({
        rowIndex,
        columnIndex,
        header: headers[columnIndex],
        data,
        style,
      })

      return (
        <VirtualizedCell {...R.omit(['data'], cellProp)}>
          {parseFloat(onlineAuxRow[curhourIdent] || 0) +
            parseFloat(offlineAuxRow[curhourIdent] || 0)}
        </VirtualizedCell>
      )
    }

    return defaultVirtualizedCellRender({
      ...params,
    })
  }

  const isEditable = ({ rowData, header }) => {
    if (
      rowData.display === 'GROSS' ||
      header.ident === 'display' ||
      header.ident === 'total'
    )
      return false

    if (hourlyGenerationwithAux && rowData.display === 'SS') return false

    if (
      rowData.display === 'NET' ||
      rowData.display === 'SS' ||
      rowData.display === 'PUMP' ||
      rowData.display === 'SYNC' ||
      rowData.display === 'ONLINE AUX' ||
      rowData.display === 'OFFLINE AUX'
    )
      return true
    return false
  }

  return (
    <div
      style={{ display: 'grid', gridTemplateColumns: '1fr', gridRowGap: '5px' }}
    >
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: [
            '100px',
            '150px',
            '100px',
            '100px',
            '200px',
            '200px',
          ]
            .filter(Boolean)
            .join(' '),
          gridColumnGap: '10px',
          alignItems: 'center',
        }}
      >
        <Button icon="edit" type="primary" onClick={_ => updateData(true)}>
          {data && data[0] && data[0].isNew ? 'Insert' : 'Update'}
        </Button>
        <Button icon="edit" type="primary" onClick={_ => updateData(false)}>
          {data && data[0] && data[0].isNew ? 'Insert' : 'Update'} & Hide
        </Button>
        {!hourlyGenerationHideDelete && (
          <Button
            disabled={data && data[0] && data[0].isNew}
            onClick={deleteData}
            type="danger"
            icon="delete"
          >
            Delete
          </Button>
        )}
        <div style={{ display: 'grid', alignContent: 'center' }}>
          {data[0] &&
            data[0].transdate &&
            moment(data[0].transdate).format('MM/DD/YYYY')}
        </div>
        <div style={{ display: 'grid', alignContent: 'center' }}>
          {data[0] && (utilityNameMap[data[0].utility] || data[0].utility)}
        </div>
        <div style={{ display: 'grid', alignContent: 'center' }}>
          {data[0] && (unitNameMap[data[0].unitId] || data[0].unitId)}
        </div>
      </div>
      <div style={{ minHeight: '180px' }}>
        <Grid
          sortEnabled
          data={data}
          headers={headers}
          // altBy={u => u.unitId}
          altBgColor="#ebebeb"
          // onEditInfoChange={info => editRow(info)}
          // editInfo={editInfo}
          render={virtualizedGridRenderer({
            headerRowHeight: 30,
            autoFixColByKey: true,
            rowHeaderRender,
            height: 200,
            width: width,
            cellRender: customizedCellRender,
          })}
          isEditable={isEditable}
          selectionMode="multi"
          selectionType="cell"
          //              initialSortOptions={headers}
          editMode="cell"
          onEditInfoChange={editInfo => onEditRow(editInfo)}
          editInfo={editInfo}
        />
      </div>
    </div>
  )
}

export default HourlyGenerationDetails

// const headers2 = [
//   dateCol({ ident: 'transdate', display: 'Transdate', isKey: true }),
//   strCol({ ident: 'utility', display: 'Utility', isKey: true }),
//   strCol({ ident: 'unit', display: 'Unit', isKey: true }),
//   numCol({ ident: 'gross1', display: 'Gross1', isFiltered: true }),
//   numCol({ ident: 'gross2', display: 'Gross2', isFiltered: true }),
//   numCol({ ident: 'gross3', display: 'Gross3', isFiltered: true }),
//   numCol({ ident: 'gross4', display: 'Gross4', isFiltered: true }),
//   numCol({ ident: 'gross5', display: 'Gross5', isFiltered: true }),
//   numCol({ ident: 'gross6', display: 'Gross6', isFiltered: true }),
//   numCol({ ident: 'gross7', display: 'Gross7', isFiltered: true }),
//   numCol({ ident: 'gross8', display: 'Gross8', isFiltered: true }),
//   numCol({ ident: 'gross9', display: 'Gross9', isFiltered: true }),
//   numCol({ ident: 'gross10', display: 'Gross10', isFiltered: true }),
//   numCol({ ident: 'gross11', display: 'Gross11', isFiltered: true }),
//   numCol({ ident: 'gross12', display: 'Gross12', isFiltered: true }),
//   numCol({ ident: 'gross13', display: 'Gross13', isFiltered: true }),
//   numCol({ ident: 'gross14', display: 'Gross14', isFiltered: true }),
//   numCol({ ident: 'gross15', display: 'Gross15', isFiltered: true }),
//   numCol({ ident: 'gross16', display: 'Gross16', isFiltered: true }),
//   numCol({ ident: 'gross17', display: 'Gross17', isFiltered: true }),
//   numCol({ ident: 'gross18', display: 'Gross18', isFiltered: true }),
//   numCol({ ident: 'gross19', display: 'Gross19', isFiltered: true }),
//   numCol({ ident: 'gross20', display: 'Gross20', isFiltered: true }),
//   numCol({ ident: 'gross21', display: 'Gross21', isFiltered: true }),
//   numCol({ ident: 'gross22', display: 'Gross22', isFiltered: true }),
//   numCol({ ident: 'gross23', display: 'Gross23', isFiltered: true }),
//   numCol({ ident: 'gross24', display: 'Gross24', isFiltered: true }),
//   numCol({ ident: 'gross2a', display: 'Gross2a', isFiltered: true }),
//   numCol({ ident: 'net1', display: 'Net1', isFiltered: true }),
//   numCol({ ident: 'net2', display: 'Net2', isFiltered: true }),
//   numCol({ ident: 'net3', display: 'Net3', isFiltered: true }),
//   numCol({ ident: 'net4', display: 'Net4', isFiltered: true }),
//   numCol({ ident: 'net5', display: 'Net5', isFiltered: true }),
//   numCol({ ident: 'net6', display: 'Net6', isFiltered: true }),
//   numCol({ ident: 'net7', display: 'Net7', isFiltered: true }),
//   numCol({ ident: 'net8', display: 'Net8', isFiltered: true }),
//   numCol({ ident: 'net9', display: 'Net9', isFiltered: true }),
//   numCol({ ident: 'net10', display: 'Net10', isFiltered: true }),
//   numCol({ ident: 'net11', display: 'Net11', isFiltered: true }),
//   numCol({ ident: 'net12', display: 'Net12', isFiltered: true }),
//   numCol({ ident: 'net13', display: 'Net13', isFiltered: true }),
//   numCol({ ident: 'net14', display: 'Net14', isFiltered: true }),
//   numCol({ ident: 'net15', display: 'Net15', isFiltered: true }),
//   numCol({ ident: 'net16', display: 'Net16', isFiltered: true }),
//   numCol({ ident: 'net17', display: 'Net17', isFiltered: true }),
//   numCol({ ident: 'net18', display: 'Net18', isFiltered: true }),
//   numCol({ ident: 'net19', display: 'Net19', isFiltered: true }),
//   numCol({ ident: 'net20', display: 'Net20', isFiltered: true }),
//   numCol({ ident: 'net21', display: 'Net21', isFiltered: true }),
//   numCol({ ident: 'net22', display: 'Net22', isFiltered: true }),
//   numCol({ ident: 'net23', display: 'Net23', isFiltered: true }),
//   numCol({ ident: 'net24', display: 'Net24', isFiltered: true }),
//   numCol({ ident: 'net2a', display: 'Net2a', isFiltered: true }),
//   numCol({ ident: 'ss1', display: 'Ss1', isFiltered: true }),
//   numCol({ ident: 'ss2', display: 'Ss2', isFiltered: true }),
//   numCol({ ident: 'ss3', display: 'Ss3', isFiltered: true }),
//   numCol({ ident: 'ss4', display: 'Ss4', isFiltered: true }),
//   numCol({ ident: 'ss5', display: 'Ss5', isFiltered: true }),
//   numCol({ ident: 'ss6', display: 'Ss6', isFiltered: true }),
//   numCol({ ident: 'ss7', display: 'Ss7', isFiltered: true }),
//   numCol({ ident: 'ss8', display: 'Ss8', isFiltered: true }),
//   numCol({ ident: 'ss9', display: 'Ss9', isFiltered: true }),
//   numCol({ ident: 'ss10', display: 'Ss10', isFiltered: true }),
//   numCol({ ident: 'ss11', display: 'Ss11', isFiltered: true }),
//   numCol({ ident: 'ss12', display: 'Ss12', isFiltered: true }),
//   numCol({ ident: 'ss13', display: 'Ss13', isFiltered: true }),
//   numCol({ ident: 'ss14', display: 'Ss14', isFiltered: true }),
//   numCol({ ident: 'ss15', display: 'Ss15', isFiltered: true }),
//   numCol({ ident: 'ss16', display: 'Ss16', isFiltered: true }),
//   numCol({ ident: 'ss17', display: 'Ss17', isFiltered: true }),
//   numCol({ ident: 'ss18', display: 'Ss18', isFiltered: true }),
//   numCol({ ident: 'ss19', display: 'Ss19', isFiltered: true }),
//   numCol({ ident: 'ss20', display: 'Ss20', isFiltered: true }),
//   numCol({ ident: 'ss21', display: 'Ss21', isFiltered: true }),
//   numCol({ ident: 'ss22', display: 'Ss22', isFiltered: true }),
//   numCol({ ident: 'ss23', display: 'Ss23', isFiltered: true }),
//   numCol({ ident: 'ss24', display: 'Ss24', isFiltered: true }),
//   numCol({ ident: 'ss2a', display: 'Ss2a', isFiltered: true }),
//   numCol({ ident: 'pump1', display: 'Pump1', isFiltered: true }),
//   numCol({ ident: 'pump2', display: 'Pump2', isFiltered: true }),
//   numCol({ ident: 'pump3', display: 'Pump3', isFiltered: true }),
//   numCol({ ident: 'pump4', display: 'Pump4', isFiltered: true }),
//   numCol({ ident: 'pump5', display: 'Pump5', isFiltered: true }),
//   numCol({ ident: 'pump6', display: 'Pump6', isFiltered: true }),
//   numCol({ ident: 'pump7', display: 'Pump7', isFiltered: true }),
//   numCol({ ident: 'pump8', display: 'Pump8', isFiltered: true }),
//   numCol({ ident: 'pump9', display: 'Pump9', isFiltered: true }),
//   numCol({ ident: 'pump10', display: 'Pump10', isFiltered: true }),
//   numCol({ ident: 'pump11', display: 'Pump11', isFiltered: true }),
//   numCol({ ident: 'pump12', display: 'Pump12', isFiltered: true }),
//   numCol({ ident: 'pump13', display: 'Pump13', isFiltered: true }),
//   numCol({ ident: 'pump14', display: 'Pump14', isFiltered: true }),
//   numCol({ ident: 'pump15', display: 'Pump15', isFiltered: true }),
//   numCol({ ident: 'pump16', display: 'Pump16', isFiltered: true }),
//   numCol({ ident: 'pump17', display: 'Pump17', isFiltered: true }),
//   numCol({ ident: 'pump18', display: 'Pump18', isFiltered: true }),
//   numCol({ ident: 'pump19', display: 'Pump19', isFiltered: true }),
//   numCol({ ident: 'pump20', display: 'Pump20', isFiltered: true }),
//   numCol({ ident: 'pump21', display: 'Pump21', isFiltered: true }),
//   numCol({ ident: 'pump22', display: 'Pump22', isFiltered: true }),
//   numCol({ ident: 'pump23', display: 'Pump23', isFiltered: true }),
//   numCol({ ident: 'pump24', display: 'Pump24', isFiltered: true }),
//   numCol({ ident: 'pump2a', display: 'Pump2a', isFiltered: true }),
//   numCol({ ident: 'sync1', display: 'Sync1', isFiltered: true }),
//   numCol({ ident: 'sync2', display: 'Sync2', isFiltered: true }),
//   numCol({ ident: 'sync3', display: 'Sync3', isFiltered: true }),
//   numCol({ ident: 'sync4', display: 'Sync4', isFiltered: true }),
//   numCol({ ident: 'sync5', display: 'Sync5', isFiltered: true }),
//   numCol({ ident: 'sync6', display: 'Sync6', isFiltered: true }),
//   numCol({ ident: 'sync7', display: 'Sync7', isFiltered: true }),
//   numCol({ ident: 'sync8', display: 'Sync8', isFiltered: true }),
//   numCol({ ident: 'sync9', display: 'Sync9', isFiltered: true }),
//   numCol({ ident: 'sync10', display: 'Sync10', isFiltered: true }),
//   numCol({ ident: 'sync11', display: 'Sync11', isFiltered: true }),
//   numCol({ ident: 'sync12', display: 'Sync12', isFiltered: true }),
//   numCol({ ident: 'sync13', display: 'Sync13', isFiltered: true }),
//   numCol({ ident: 'sync14', display: 'Sync14', isFiltered: true }),
//   numCol({ ident: 'sync15', display: 'Sync15', isFiltered: true }),
//   numCol({ ident: 'sync16', display: 'Sync16', isFiltered: true }),
//   numCol({ ident: 'sync17', display: 'Sync17', isFiltered: true }),
//   numCol({ ident: 'sync18', display: 'Sync18', isFiltered: true }),
//   numCol({ ident: 'sync19', display: 'Sync19', isFiltered: true }),
//   numCol({ ident: 'sync20', display: 'Sync20', isFiltered: true }),
//   numCol({ ident: 'sync21', display: 'Sync21', isFiltered: true }),
//   numCol({ ident: 'sync22', display: 'Sync22', isFiltered: true }),
//   numCol({ ident: 'sync23', display: 'Sync23', isFiltered: true }),
//   numCol({ ident: 'sync24', display: 'Sync24', isFiltered: true }),
//   numCol({ ident: 'sync2a', display: 'Sync2a', isFiltered: true }),
// ]
